import React from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
const Image = dynamic(() => import('../Image/Image'));

export default function CloudinaryImage({document}) {
    const classNames = document?.fields?.className;

    return (<div className={classNames}>
        <Image image={document}/>
    </div>);
}

CloudinaryImage.propTypes = {
    document: PropTypes.object,
};